import React, { useContext } from 'react'
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import ViewHistoryModal from 'modules/real-property-tax/building/application/components/history/modals/ViewHistoryModal';
import * as actions from '../action';

/* eslint-disable react/no-unescaped-entities */
function MemorandaModal({ memorandaData, type }) {

  const setModal = useContext(ModalContext);

  const createMarkup = (text) => {
    return { __html: text };
  }

  const handleOnViewHistory = e => {
    e.preventDefault();
    setModal({
      title: "View History",
      isOpen: true,
      content: <ViewHistoryModal dataInfo={memorandaData} />,
      modalSize: 'modal-lg',
    });
  };

  return (
    <div className="row d-flex  mb-1 p-3">
      {type === 'history' && (
        <button onClick={handleOnViewHistory} type="button" className="btn btn-link">
          <i className="fas fa-chevron-left back-login" /> Back
        </button>
      )}
      <div className="col-12 mt-1">
        <span className="transaction-text p-0">
          <div
            // eslint-disable-next-line
            dangerouslySetInnerHTML={createMarkup(_.get(memorandaData, 'attributes.memoranda') || '--')}
          />
        </span>
      </div>
    </div>
  )
}

MemorandaModal.defaultProps = {
  type: '',
};

MemorandaModal.propTypes = {
  memorandaData: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string,
}

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MemorandaModal);